import type { ConsentTemplate, ConsentTemplateGroup } from './types';

/**
 * Groups revisions by key (the API sorts by key, then newest revision first),
 * keeping the API's key order. The latest revision gives the row's title.
 */
export function groupByKey(rows: ConsentTemplate[]): ConsentTemplateGroup[] {
  const byKey = new Map<string, ConsentTemplate[]>();
  for (const t of rows) byKey.set(t.key, [...(byKey.get(t.key) ?? []), t]);
  return [...byKey.entries()].map(([key, list]) => {
    const revisions = [...list].sort((a, b) => b.revision - a.revision);
    return {
      key,
      revisions,
      latest: revisions[0],
      approved: revisions.find((t) => t.status === 'approved') ?? null,
      draft: revisions.find((t) => t.status === 'draft') ?? null,
    };
  });
}
